import React from "react";

// Images
import HACKTOBERFEST_POSTER from "../../images/events/Hacktoberfest/hacktoberfest-2024.png";

// Material-UI components
import { Box, Typography } from "@mui/material";

export default function HacktoberfestHomePage() {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          color: "white",
          px: { xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }, // Add padding for smaller screens
        }}
      >
        <Typography
          variant="h3"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "rgba(255, 255, 255, 0.08)",
            px: 2,
            py: 1, // Adjust padding for smaller screens
            borderRadius: 2,
            my: 2,
            mb: 6,
            fontSize: {
              xs: "1.5rem", // Smaller font size for extra small screens
              sm: "2rem", // Slightly larger for small screens
              md: "2.5rem", // Medium screens
              lg: "3rem", // Large screens
            },
            textAlign: "center", // Ensure text is centered across screen sizes
          }}
        >
          Hacktoberfest
        </Typography>
        <Box
          sx={{
            width: "100%", // Ensures the container is full width
            maxWidth: {
              xs: "90%", // Max width for extra small screens
              sm: "80%", // Small screens
              md: "70%", // Medium screens
              lg: "60%", // Large screens
            },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={HACKTOBERFEST_POSTER}
            alt="HACKTOBERFEST_POSTER"
            style={{
              width: "100%", // Ensures the image scales to the parent's width
              height: "auto", // Maintains the aspect ratio
              borderRadius: "16px",
              objectFit: "contain", // Ensures the image fits within the container without distortion
            }}
          />
        </Box>
      </Box>
      <Box sx={{ mb: { xs: 10, sm: 20 } }}>&nbsp;</Box>{" "}
      {/* Adjust bottom margin */}
    </>
  );
}
